const thankYou = {
    title: 'Thank you',
    tagLine_q: 'Thank you for submitting your question! ',
    tagLine_a: 'Thank you for submitting your application! Fill in the calender to immediately make an appointment with me',
    button: 'GO BACK TO THE SITE'
}
export default thankYou;